
//import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Create, DateInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { dateArriveValidation, getAdr, statusCampagneCrea, typeCampagne } from '../references.js';





/*
const useStyles = makeStyles({
    inlineBlock: {  marginRight: '10rem' },
});
*/
const  CreateCampagne =(props,...rest) => {


    const [adrDepCampagnes, setAdrDepCampagnes] = useState([]);
    const [adrArrCampagnes, setAdrArrCampagnes] = useState([]);

    const [formData, setFormData] = useState();
    const [defaultValues, setDefaultValues] = useState(null);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
   

    useEffect(() => {
       /*
        var adresses =JSON.parse(localStorage.getItem('adrCampagnes'));
        if(adresses && formData && formData.type==='MARITIME'){
            let ret =fret_handleTypeFret(adresses,formData.type,'DEP_MARITIME','ARR_MARITIME',2,13);
            setAdrDepCampagnes(ret.list_adr_dep);
            setAdrArrCampagnes(ret.list_adr_arr);
            setDefaultValues(ret.defaultValues);
            console.log(ret.defaultValues)

        }

        if(adresses && formData && formData.type==='AERIEN'){
            let ret =fret_handleTypeFret(adresses,formData.type,'DEP_AERIEN','ARR_AERIEN',3,10);
            setAdrDepCampagnes(ret.list_adr_dep);
            setAdrArrCampagnes(ret.list_adr_arr);
            setDefaultValues(ret.defaultValues);

        }

        if(adresses && formData && formData.type==='AERIEN_DE_CNKRY'){
            let ret =fret_handleTypeFret(adresses,formData.type,'DEP_AERIEN_CNKRY','ARR_AERIEN_CNKRY',9,5);
            setAdrDepCampagnes(ret.list_adr_dep);
            setAdrArrCampagnes(ret.list_adr_arr);
            setDefaultValues(ret.defaultValues);

        }

        if(adresses && formData && formData.type==='VEHICULE'){
            let ret =fret_handleTypeFret(adresses,formData.type,'DEP_VEHICULE','ARR_VEHICULE',2,13);
            setAdrDepCampagnes(ret.list_adr_dep);
            setAdrArrCampagnes(ret.list_adr_arr);
            setDefaultValues(ret.defaultValues);

        }
        */
        
       //setDefaultValues({adrDeptId:3,adrArrId:10,status:'ATTENTE'});
        
    }, []);



    //if(!defaultValues) return <Loading loadingPrimary="app.page.loading" loadingSecondary="Chargement ..." />
    const TypeChange=(e)=>{
        //console.log(getAdr(e.target.value))
        setDefaultValues(()=>getAdr(e.target.value))
    }
//console.log(defaultValues);
  return (
  
      <Create {...props} title="Création d'une campagne"   >
        <SimpleForm {...props}  submitOnEnter={true} redirect="show" margin="none"   >
          { isSmall ?
              <SelectInput {...rest} fullWidth source="status" label="Status" validate={required()} choices={statusCampagneCrea} initialValue={'ATTENTE'} />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="status" label="Status" validate={required()} choices={statusCampagneCrea} initialValue={'ATTENTE'} />
          } 
          { isSmall ?
              <SelectInput {...rest} fullWidth source="type" label="Type campagne" validate={required()} choices={typeCampagne} onChange={TypeChange}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="type" label="Type campagne" validate={required()} choices={typeCampagne}  onChange={TypeChange} />
          } 

        {isSmall ?     
                    <SelectInput {...rest} fullWidth   source="adrDeptId" 
                        label="Adresse départ" validate={required()} 
                        choices={defaultValues && defaultValues.list_adr_dep? defaultValues.list_adr_dep: []}   
                        />
                    :
                    
                    <SelectInput {...rest}    
                        style={{width:'50%'}} source="adrDeptId" 
                        label="Adresse départ" validate={required()} 
                        choices={defaultValues && defaultValues.list_adr_dep? defaultValues.list_adr_dep: []} 
                        />
                }
                {
                    isSmall ?     
                    <SelectInput {...rest} fullWidth   source="adrArrId" label="Adresse arrivée" 
                        validate={required()} 
                        choices={defaultValues && defaultValues.list_adr_arr? defaultValues.list_adr_arr: []} 
                    />
                    :
                    
                    <SelectInput {...rest}    style={{width:'50%'}} source="adrArrId" label="Adresse arrivée" 
                        validate={required()} 
                        choices={defaultValues && defaultValues.list_adr_arr? defaultValues.list_adr_arr: []} 
                    />
                }

         { isSmall ?  
          <DateInput {...rest}  fullWidth source="dateDepart" label="Date départ"  validate={required()}   />
            :
            <DateInput {...rest}   style={{width:'50%'}}  source="dateDepart" label="Date départ"  validate={required()}   />

         }
           { isSmall ?  
          <DateInput {...rest} fullWidth  source="dateArrive" label="Date arrivé"  validate={[dateArriveValidation]}   />
            :
            <DateInput {...rest} style={{width:'50%'}}  source="dateArrive" label="Date arrivé"  validate={[dateArriveValidation]}   />
           }
          { isSmall ?  
          <TextInput  {...rest} fullWidth  multiline source="numero"  label="Numéro"  />
          :
          <TextInput  {...rest} style={{width:'50%'}}  multiline source="numero"  label="Numéro"  />

           }

           { isSmall ?  
          <TextInput  {...rest} fullWidth  multiline source="commentaire"  label="Commentaire"  />
          :
          <TextInput  {...rest} style={{width:'50%'}}  multiline source="commentaire"  label="Commentaire"  />

           }

        </SimpleForm>
    </Create>
    );
}

export default CreateCampagne;